module.exports = __webpack_public_path__ + "static/img/2areaA_19.871c857.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/2areaA_19.png
// module id = 898
// module chunks = 1